/* @flow */

import React from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import { Route, IndexRedirect } from 'react-router'

import App from './App'
import LoginPage from './LoginPage'
import SettingsPage from './SettingsPage'
import NewPollPage from './NewPollPage'
import ExistingPollPage from './ExistingPollPage'
import PollAnalytics from './PollAnalytics'

import LibraryPage from './LibraryPage'
import AutomationPage from './Pages/Automation'

import Report from './Pages/Report/index'
import Analytics from './Analytics'

import PublisherReport from './Pages/Report/publisherReports'
import Revenue from './Pages/Report/revenueReports'

import {
  OLD_LIBRARY_URL,
  LIBRARY_URL_ALL,
  LIBRARY_URL_RECOMMENDED,
  SETTINGS_URL,
  OLD_LOGIN_URL,
  ANALYTICS_URL,
  REPORT_URL,
  AUTOMATION_ARTICLES_URL,
  AUTOMATION_BLACKLIST_URL,
  urlForNewPollWherePollTypeId,
  urlForPollWhereId,
  urlForPollAnalyticsWhereId,
  AUTOMATIONS_URL,
  PUBLISHER_REPORT_URL,
  PUBLISHER_REVENUE_URL,
} from '../urls'
import RequireAuth from './RequireAuth/RequireAuth'

export default function Root(props: { store: Object, history: Object }) {
  const { store } = props

  return (
    <Provider store={store}>
      <Router history={props.history}>
        <Route path="/" component={App}>
          <IndexRedirect to={OLD_LIBRARY_URL} />
          <Route path={OLD_LIBRARY_URL}>
            <IndexRedirect to={LIBRARY_URL_RECOMMENDED} />
            <Route
              path={LIBRARY_URL_ALL}
              component={() => (
                <RequireAuth>
                  <LibraryPage tab="all" />
                </RequireAuth>
              )}
            />
            <Route
              path={LIBRARY_URL_RECOMMENDED}
              component={() => (
                <RequireAuth>
                  <LibraryPage tab="recommended" />
                </RequireAuth>
              )}
            />
            <Route
              path={AUTOMATIONS_URL}
              component={() => (
                <RequireAuth>
                  <LibraryPage tab="automation" />
                </RequireAuth>
              )}
            />
          </Route>

          <Route
            path={ANALYTICS_URL}
            component={() => (
              <RequireAuth>
                <Analytics />
              </RequireAuth>
            )}
          />

          <Route
            path={REPORT_URL}
            component={props => (
              <RequireAuth>
                <Report {...props} />
              </RequireAuth>
            )}
          />
          <Route
            path={PUBLISHER_REPORT_URL}
            component={props => (
              <RequireAuth>
                <PublisherReport {...props} />
              </RequireAuth>
            )}
          />

          <Route
            path={PUBLISHER_REVENUE_URL}
            component={props => (
              <RequireAuth>
                <Revenue {...props} />
              </RequireAuth>
            )}
          />

          <Route
            path={AUTOMATION_ARTICLES_URL}
            component={() => (
              <RequireAuth>
                <AutomationPage tab="articles" />
              </RequireAuth>
            )}
          />
          <Route
            path={AUTOMATION_BLACKLIST_URL}
            component={() => (
              <RequireAuth>
                <AutomationPage tab="blacklist" />
              </RequireAuth>
            )}
          />

          <Route
            path={urlForNewPollWherePollTypeId(':pollTypeId')}
            component={props => (
              <RequireAuth>
                <NewPollPage {...props} />
              </RequireAuth>
            )}
          />
          <Route
            path={urlForPollWhereId(':pollId')}
            component={props => (
              <RequireAuth>
                <ExistingPollPage {...props} />
              </RequireAuth>
            )}
          />
          <Route
            path={urlForPollAnalyticsWhereId(':pollId')}
            component={props => (
              <RequireAuth>
                <PollAnalytics {...props} />
              </RequireAuth>
            )}
          />

          <Route
            path={SETTINGS_URL}
            component={props => (
              <RequireAuth>
                <SettingsPage {...props} />
              </RequireAuth>
            )}
          />
          <Route path={OLD_LOGIN_URL} component={LoginPage} />
        </Route>
      </Router>
    </Provider>
  )
}



// WEBPACK FOOTER //
// ./src/components/Root.js